/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import dtm from 'scripts/services/dtm';
import championshipsSelectionTabsComponent from './championships-selection-tabs.stache';

export const ChampionshipsSelectionTabs = BaseControl.extend({
    init() {
        this._super();
        const $wrapper = this.element.find('.s-selection-tabs-wrapper');
        $wrapper.append(championshipsSelectionTabsComponent({data: this.options.data}));
    },
    '.s-selection-tabs .b-selection-tabs__tab click': function ($element) {
        const toggleName = $element.text().trim();
        dtm.trackChampionshipsPlayerStatisticsToggle(toggleName);
    }
});
